import { Radio } from "@base-ui/react/radio";
import { RadioGroup } from "@base-ui/react/radio-group";
import { Controller, useFormContext } from "react-hook-form";
import ExtendedImage from "@/components/ui/extended-image";
import type { Question } from "@/types/content";

const ImageQuestion = ({ question }: { question: Question }) => {
  const { control } = useFormContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="relative w-full aspect-video">
        <ExtendedImage
          alt={question.id}
          className="rounded-2xl max-h-96 aspect-video"
          fill={true}
          src={question.image}
        />
      </div>
      <p className="leading-5 font-medium">{question.text}</p>
      <Controller
        control={control}
        defaultValue=""
        name={question.id}
        render={({ field }) => {
          return (
            <RadioGroup
              aria-labelledby={question.id}
              className="grid grid-cols-[9rem_9rem] mx-auto gap-2"
              onValueChange={field.onChange}
              {...field}
            >
              {question.options.map((option) => (
                <label
                  className="relative border border-gray-300 rounded-xl size-36 gap-2"
                  htmlFor={option.id}
                  key={option.id}
                >
                  <ExtendedImage
                    alt={option.label}
                    className="absolute  inset-0 rounded-xl size-36"
                    height={50}
                    src={option.image}
                    width={50}
                  />
                  <Radio.Root
                    className="flex size-5 z-10 absolute top-2 right-2 bg-white items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 data-checked:bg-white data-checked:border data-checked:border-brand-blue-600 data-unchecked:border data-unchecked:border-gray-300"
                    id={option.id}
                    value={option.id}
                  >
                    <Radio.Indicator className="flex before:size-3 before:rounded-full before:bg-brand-blue-600 data-unchecked:hidden" />
                  </Radio.Root>
                </label>
              ))}
            </RadioGroup>
          );
        }}
      />
    </div>
  );
};

export default ImageQuestion;
